import { useQuery } from '@tanstack/react-query';
import { formatBytes } from '../../lib/format';
import { Spinner } from '../../components/ui';
import { getAdminOverview } from '../../lib/api';

export function AdminOverviewPage() {
  const overview = useQuery({ queryKey: ['admin', 'overview'], queryFn: getAdminOverview });

  if (overview.isPending) {
    return (
      <div className="flex h-64 items-center justify-center">
        <Spinner />
      </div>
    );
  }
  if (overview.isError || !overview.data) {
    return <p className="text-sm text-red-600">Couldn’t load platform usage.</p>;
  }
  const d = overview.data;

  const stats = [
    { label: 'Active workspaces', value: d.workspaces.active, hint: `${d.workspaces.deleted} in recycle bin` },
    { label: 'Users', value: d.users },
    { label: 'Magazines', value: d.projects },
    { label: 'PDF proofs', value: d.proofs },
    { label: 'Versions', value: d.versions },
    { label: 'Storage used', value: formatBytes(d.storageBytes) },
  ];

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-xl font-bold tracking-tight text-neutral-900">Overview</h1>
        <p className="mt-1 text-sm text-neutral-500">Usage across the whole platform.</p>
      </div>

      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
        {stats.map((s) => (
          <div key={s.label} className="rounded-xl border border-neutral-200 bg-white p-4">
            <p className="text-xs font-medium text-neutral-500">{s.label}</p>
            <p className="mt-1 text-2xl font-bold tracking-tight text-neutral-900">
              {typeof s.value === 'number' ? s.value.toLocaleString() : s.value}
            </p>
            {s.hint && <p className="mt-0.5 text-[11px] text-neutral-400">{s.hint}</p>}
          </div>
        ))}
      </div>

      <div>
        <h2 className="text-sm font-semibold text-neutral-900">Plans</h2>
        <div className="mt-3 grid grid-cols-3 gap-4">
          {(['FREE', 'PRO', 'BUSINESS'] as const).map((plan) => (
            <div key={plan} className="rounded-xl border border-neutral-200 bg-white p-4">
              <p className="text-xs font-medium capitalize text-neutral-500">{plan.toLowerCase()}</p>
              <p className="mt-1 text-2xl font-bold tracking-tight text-neutral-900">
                {d.planBreakdown[plan].toLocaleString()}
              </p>
              <p className="mt-0.5 text-[11px] text-neutral-400">accounts</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
